import React from 'react';
import { Paper, Tabs, Tab, Box, alpha, useTheme } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import HubIcon from '@mui/icons-material/Hub';
import ListAltIcon from '@mui/icons-material/ListAlt';

const DashboardNav = () => {
  const [value, setValue] = React.useState(0);
  const theme = useTheme();

  const handleScrollTo = (id, index) => {
    setValue(index);
    const element = document.getElementById(id);
    if (element) {
      // Offset for the sticky header height
      const offset = 140; 
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <Paper 
      elevation={0}
      sx={{ 
        position: 'sticky', 
        top: 65, // Adjust based on your Main AppBar height
        zIndex: 1100,
        borderRadius: 0,
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: alpha(theme.palette.background.paper, 0.9),
        backdropFilter: 'blur(8px)',
        mx: -3, // Offset parent padding to go full-width
        px: 3,
      }}
    >
      <Tabs 
        value={value} 
        variant="scrollable" 
        scrollButtons="auto"
        textColor="inherit"
        indicatorColor="secondary"
      >
        <Tab 
          icon={<DashboardIcon fontSize="small" color='inherit' />} 
          iconPosition="start" 
          label="Executive Pulse" 
          onClick={() => handleScrollTo('pulse-section', 0)} 
        />
        <Tab 
          icon={<HubIcon fontSize="small" color='inherit' />} 
          iconPosition="start" 
          label="Operations" 
          onClick={() => handleScrollTo('ops-section', 1)} 
        />
        <Tab 
          icon={<ShowChartIcon fontSize="small" color='inherit' />} 
          iconPosition="start" 
          label="Impact & Analytics" 
          onClick={() => handleScrollTo('impact-section', 2)} 
        />
        <Tab 
          icon={<ListAltIcon fontSize="small" color='inherit' />} 
          iconPosition="start" 
          label="Detailed Logs" 
          onClick={() => handleScrollTo('logs-section', 3)} 
        />
      </Tabs>
    </Paper>
  );
};

export default DashboardNav;